import React from "react";
import { Disclosure, Transition } from "@headlessui/react";
import { MinusIcon, PlusIcon } from "@heroicons/react/outline";
import Body from "components/Body";
import Image from "next/image";

export default function ParagraphDisclosure({ data, loopIndex }) {
  const hasImage = data.field_image || false;
  const icons = {
    true: MinusIcon,
    false: PlusIcon,
  };

  return (
    <Disclosure
      as="div"
      defaultOpen={loopIndex === 0}
      className="shadow-spread rounded-md overflow-hidden mb-4"
    >
      {({ open }) => {
        const IconComponent = icons[open];

        return (
          <>
            <Disclosure.Button className="flex items-center text-left w-full bg-primary text-white py-5 px-10 hover:bg-primary-dark transition-colors">
              <span className="flex-1 font-important font-medium text-xl">
                {data.field_title}
              </span>
              <span className="p-2 bg-white rounded-full">
                <IconComponent className="h-5 w-5 text-primary transition-all" />
                <span className="sr-only">{open ? "Replier" : "Déplier"}</span>
              </span>
            </Disclosure.Button>
            {open && (
              <Transition
                show={open}
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
              >
                <Disclosure.Panel
                  className="flex flex-col gap-6 lg:flex-row p-10 bg-secondary-light lg:py-6"
                  static
                >
                  {hasImage && (
                    <figure className="relative w-full lg:w-1/3">
                      <div className="aspect-w-16 aspect-h-10">
                        <Image
                          src={data.field_image.image_style_uri.large_scale}
                          {...data.field_image.resourceIdObjMeta}
                          layout="fill"
                          objectFit="contain"
                          quality={100}
                        />
                      </div>
                    </figure>
                  )}
                  <div className="flex-1 prose max-w-none">
                    <Body value={data.field_text.processed} />
                  </div>
                </Disclosure.Panel>
              </Transition>
            )}
          </>
        );
      }}
    </Disclosure>
  );
}
